import { render, staticRenderFns } from "./ReporteGeneralBeta.vue?vue&type=template&id=e95125f2&"
import script from "./ReporteGeneralBeta.vue?vue&type=script&lang=js&"
export * from "./ReporteGeneralBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports